module.exports = __webpack_public_path__ + "static/img/gpt23.a06848fc.png";